/*
 * WaWiItemsAppQueries.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-02 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import gql from 'graphql-tag';

import {
  AUFTRAGSPOSITION_FRAGMENT,
  BESTANDSBUCHSUMME_FRAGMENT,
  BESTELLPOSITION_FRAGMENT,
  ITEM_FRAGMENT,
  ITEM_PIM_FRAGMENT,
  PREIS_FRAGMENT,
  RESERVIERUNGSPOSITION_FRAGMENT,
  SKUM_FRAGMENT,
  SKU_FRAGMENT,
  WERTKORREKTUR_FRAGMENT,
  ZUTEILUNG_FRAGMENT,
} from '../fragments';

export const SUGGESTIONS_QUERY = gql`
  query SearchItem3Query($term: String!) {
    fulltextSearch: h3ItemSearch(term: $term) {
      id
      designator
      title
      score
    }
  }
`;

export const ITEM_QUERY = gql`
  query Item($nr: ID!) {
    entity: h3Item(designator: $nr) {
      ...itemFragment
    }
  }
  ${ITEM_FRAGMENT}
`;

export const ITEM_WITH_MASTER_AND_LEGACY_QUERY = gql`
  query ItemEtc($nr: ID!) {
    entity: h3Item(designator: $nr) {
      ...itemFragment
      imageUrl
      preisResolved {
        ...preisLFragment
      }
      skuMasterList {
        ...skuMasterFragment
        skuList {
          ...skuFragment
        }
      }
      eapSimulator {
        eap2
        eap3
      }
    }
  }
  ${ITEM_FRAGMENT}
  ${PREIS_FRAGMENT}
  ${SKUM_FRAGMENT}
  ${SKU_FRAGMENT}
`;
export const PIM_QUERY = gql`
  query ItemPimLesen($nr: ID!) {
    h3Item(designator: $nr) {
      id
      designator
      entity: pim {
        ...itemInfoFragment
      }
    }
  }
  ${ITEM_PIM_FRAGMENT}
`;
export const ARTIKELKONTO_QUERY = gql`
  query ItemArtikelkontoLesen($nr: ID!) {
    h3Item(designator: $nr) {
      id
      nodes: konto {
        bartnr
        bestand
        bewegung
        created_at
        datum_bis
        datum
        datum_von
        designator
        freie_menge
        lager
        typ
        updated_at
        partnernr
        partnerName
        verspaetet
        vorgangsnr
      }
    }
  }
`;

export const AUFTRAG_LIST_QUERY = gql`
  query ItemAuftraege($nr: ID!) {
    entity: h3Item(designator: $nr) {
      nodes: auftragsPositionen(filter: { erledigt: { eq: false } }) {
        ...auftragspositionFragment
        kunde {
          id
          name
        }
      }
    }
  }
  ${AUFTRAGSPOSITION_FRAGMENT}
`;

export const RESERVIERUNG_LIST_QUERY = gql`
  query ItemReservierungen($nr: ID!) {
    entity: h3Item(designator: $nr) {
      nodes: reservierungsPositionen(filter: { erledigt: { eq: false } }) {
        ...resevierungspositionFragment
      }
    }
  }
  ${RESERVIERUNGSPOSITION_FRAGMENT}
`;

export const BESTELL_LIST_QUERY = gql`
  query IBQuery($nr: ID!) {
    entity: h3Item(designator: $nr) {
      ...itemFragment
      skuMasterList {
        id
        nodes: bestellPositionList(filter: { erledigt: { eq: false } }) {
          ...bestellpositionFragment
        }
      }
    }
  }
  ${ITEM_FRAGMENT}
  ${BESTELLPOSITION_FRAGMENT}
`;

export const BESTAND_LIST_QUERY = gql`
  query IBestQuery($nr: ID!) {
    entity: h3Item(designator: $nr) {
      skuMasterList {
        skuList {
          nodes: bestaende {
            ...bestandsbuchsummeFragment
          }
        }
      }
    }
  }
  ${BESTANDSBUCHSUMME_FRAGMENT}
`;

export const ZUTEILUNG_LIST_QUERY = gql`
  query IZQuery($nr: ID!) {
    entity: h3Item(designator: $nr) {
      skuMasterList {
        nodes: icZuteilungList {
          ...zuteilungFragment
        }
      }
    }
  }
  ${ZUTEILUNG_FRAGMENT}
`;
